<template>
  <pageContent class="privacidad">
    <div class="privacidad-main">
      <div class="row-text">
        <h1 class="font-blod fade-in">Política de Privacidad</h1>
      </div>
      <div class="text">
        <p class="fade-in">
          Cuando precisemos obtener información por su parte, siempre le
          solicitaremos que nos la proporcione voluntariamente de forma expresa.
          Los datos recabados a través de los formularios de recogida de datos
          del sitio web u otras vías serán incorporados a los sistemas de
          tratamiento de
          <b class="font-blod"> MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L.</b>
        </p>
        <p class="fade-in">
          Esta entidad tratará los datos de forma confidencial y exclusivamente
          con la finalidad de ofrecer los servicios solicitados, con todas las
          garantías legales y de seguri dad que impone el Reglamento (UE)
          2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016,
          relativo a la protección de las personas físicas en lo que respecta al
          tratamiento de datos personales y a la libre circulación de estos
          datos y la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de
          la Información y Comercio Electrónico.
        </p>
      </div>
      <el-collapse class="collapse" accordion v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i> ¿Quién es el responsable
            de tratamiento de sus datos?
          </template>
          <p>
            Nuestro sitio web, HTTPS://MARAGONCONSTRUCCION.ES/ (en adelante: “el
            sitio web”) utiliza cookies y otras tecnologías relacionadas (para
            mayor comodidad, todas las tecnologías se denominan “cookies”). Las
            cookies también son colocadas por terceros que hemos contratado. En
            el siguiente documento le informamos sobre el uso de cookies en
            nuestro sitio web.
          </p>
          <div class="no-padding">
            <p>
              El responsable es
              <b class="font-blod"> MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L.</b>
            </p>
            <p>Su CIF es: <b class="font-blod"> B01705003</b></p>
            <p>
              Su domicilio está en:
              <b class="font-blod">CALLE GÜNTER, 1, 28906 GETAFE, MADRID</b>
            </p>
            <p>
              Correo electrónico:
              <el-link type="primary"  href="mailto:info@maragonconstruccion.es"> info@maragonconstruccion.es</el-link>
            </p>
            <p>
              Registro mercantil tomo
              <b class="font-blod"
                >40665 folio 70 hoja M-721662 CONTACTO DELEGADO
              </b>
            </p>
            <p>
              DE PROTECCIÓN DE DATOS:
              <el-link type="primary"  href="mailto:info@maragonconstruccion.es">info@maragonconstruccion.es</el-link>
            </p>
          </div>
        </el-collapse-item>

        <el-collapse-item name="2">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i> ¿Con que finalidad
            tratamos sus datos personales?
          </template>
          <p>
            En
            <b class="font-blod">MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L.</b>
            tratamos la información que nos facilitan los interesados de manera
            leal, lícita y transparente dando cumplimiento a la normativa UE
            2016/679 de 27 de abril del Parlamento Europeo y del Consejo y Ley
            3/2018 de 5 de diciembre de Protección de datos y ga-rantía de
            derechos digitales.
          </p>
          <p style="text-decoration: underline">Si eres CLIENTE o USUARIO:</p>
          <p>
            Si eres cliente o usuario, trataremos las siguientes categorías de
            datos personales:
          </p>
          <ul>
            <li>Datos identificativos (nombre, apellidos, DNI…)</li>
            <li>Datos de contacto (correo electrónico, Whatsapp…)</li>
            <li>Datos bancarios (número de cuenta, tarjeta bancaria…)</li>
            <li>
              Otros datos (facilitados por el interesado en formularios abiertos
              o comunicaciones)
            </li>
          </ul>
          <p>Tratamos tus datos con la finalidad de:</p>
          <ul>
            <li>
              Gestionar los servicios, información y/o productos solicitados.
            </li>
            <li>
              Enviar comunicaciones de interés (si el interesado hubiera
              prestado la debida autorización)
            </li>
            <li>Cumplir las obligaciones legales aplicables al responsable.</li>
          </ul>

          <p style="text-decoration: underline">
            Si eres EMPLEADO o SOLICITANTE DE EMPLEO:
          </p>
          <p>
            Si eres empleado o solicitante/candidato, trataremos las siguientes
            categorías de datos personales
          </p>
          <ul>
            <li>Datos identificativos (nombre, apellidos, DNI…)</li>
            <li>
              Datos incluidos en el currículum vitae (Estudios, experiencia
              laboral, aficiones…)
            </li>
            <li>Datos de contacto (correo electrónico, Whatsapp…)</li>
            <li>Datos bancarios (número de cuenta, titular, mandato SEPA)</li>
            <li>Imagen</li>
            <li>
              Otros datos (facilitados por el interesado en formularios abiertos
              o comunicaciones)
            </li>
          </ul>
          <p>Tratamos tus datos con la finalidad de:</p>
          <ul>
            <li>
              Gestionar los derechos y obligaciones relativos a la relación
              contractual.
            </li>
            <li>Selección de candidatos</li>
            <li>
              Uso, reproducción o publicación de imagen, nombre y voz (si el
              interesado hubiera prestado la debida autorización)
            </li>
            <li>Cumplir las obligaciones legales de las empresas.</li>
          </ul>
          <p style="text-decoration: underline">
            Si eres EMPLEADO o SOLICITANTE DE EMPLEO:
          </p>
          <p>
            Si eres proveedor, trataremos las siguientes categorías de datos
            personales:
          </p>
          <ul>
            <li>Datos identificativos (nombre, apellidos, DNI…)</li>
            <li>Datos de contacto (correo electrónico, Whatsapp…)</li>
            <li>Datos bancarios (número de cuenta, facturación…)</li>
            <li>
              Otros datos (facilitados por el interesado en formularios abiertos
              o comunicaciones)
            </li>
          </ul>
          <p style="text-decoration: underline">
            Tratamos tus datos con la finalidad de:
          </p>
          <ul>
            <li>Gestión administrativa, contable y fiscal.</li>
            <li>Seguimiento y control de la relación mercantil.</li>
            <li>Cumplir las obligaciones legales de las empresas</li>
          </ul>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>¿Estoy obligado a facilitar
            los datos personales?
          </template>
          <p>
            <b class="font-blod">MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L. </b
            >solo solicitará los datos estrictamente necesarios para la
            realización de la finalidad para la cual son recabados, por lo que
            en caso de no ser facilitados no podrá prestarse el servicio
            solicitado.
          </p>
        </el-collapse-item>

        <el-collapse-item name="4">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>¿Por cuánto tiempo
            conservaremos sus datos+
          </template>
          <p>
            Los datos personales proporcionados y obtenidos durante la relación
            entre el interesado y MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L. serán
            conser vados durante un plazo máximo de 5 años a partir de la última
            confirmación de interés o mientras nos obligue una previsión legal,
            en cuyo caso serán con servados debidamente bloqueados y eliminados
            cuando no sea necesario.
          </p>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>¿Cuál es la legitimación
            para el tratamiento de sus datos?
          </template>
          <p>
            En cumplimiento del artículo 6.1 del Reglamento UE 2016/679 de 27 de
            abril le informamos que la legitimación para el tratamiento de sus
            datos es la siguiente:
          </p>
          <ul>
            <li>
              el interesado dio su consentimiento para el tratamiento de sus
              datos personales para uno o varios fines específicos y/o
            </li>
            <li>
              el tratamiento es necesario para el cumplimiento de una obligación
              legal aplicable al responsable del tratamiento y/o
            </li>
            <li>
              el tratamiento es necesario para la satisfacción de intereses
              legítimos perseguidos por el responsable del tratamiento o por un
              tercero, siempre que sobre dichos inter eses no prevalezcan los
              intereses o los derechos y libertades fundamentales del interesado
              que requieran la protección de datos personales, en particular
              cuando el interesado sea un niño.
            </li>
          </ul>
        </el-collapse-item>
        <el-collapse-item name="5">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>¿A qué destinatarios se
            comunicarán sus datos?
          </template>
          <p>
            Los datos tratados por
            <b class="font-blod"> MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L.</b>
            podrán ser comunicados a terceros cuando así nos obligue una
            previsión legal. Asimismo<b class="font-blod">
              MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L.</b
            >
            cuenta con proveedores de servicios para los cuales es necesario
            realizar comunicación de datos en diferentes áreas empresariales
            (administración, contabilidad, fiscalidad, marketing, laboral…). La
            relación con estas empresas está regulada según el artículo 28 del
            Reglamento UE 2016/679 de 27 de abril del Parlamento Europeo y del
            Consejo (RGPD). Los datos accedidos desde dichas empresas solo serán
            utilizados para el fin empresarial necesario no siendo conservados
            para cualquier fin ulterior
          </p>
        </el-collapse-item>
        <el-collapse-item name="6">
          <template slot="title">
            <i class="header-icon el-icon-minus"></i>¿Cuáles son sus derechos
            cuando nos facilita sus datos?
          </template>
          <p>
            Cualquier interesado tiene derecho a obtener confirmación sobre si
            en MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L. estamos tratando los
            datos perso nales que le conciernan o no
          </p>
          <p>
            Las personas interesadas tienen derecho a acceder a sus datos
            personales, así como solicitar la rectificación de datos inexactos
            o, en su caso, solicitar su supresión cuando, entre otros motivos,
            los datos ya no sea necesarios para los fines para los que fueron
            recogidos.
          </p>
          <p>
            En determinadas circunstancias, los interesados podrán solicitar la
            limitación del tratamiento de sus datos, en cuyo caso únicamente los
            conservaremos para el ejercicio o la defensa de reclamaciones. Los
            usuarios también podrán oponerse al tratamiento de sus datos.
            MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L. dejará de tratar los datos,
            salvo por motivos legítimos imperiosos, o en el ejercicio o defensa
            de reclamaciones.
          </p>
          <p>
            El usuario puede enviar un escrito a MARAGON EFICIENCIA EN
            CONSTRUCCIÓN S.L., al domicilio del responsable, o bien por medio de
            un correo electrónico indicado en el encabezado de la presente
            Política, adjuntando fotocopia de su documento de identidad, en
            cualquier momento y de manera gratuita, para:
          </p>
          <ul>
            <li>
              Revocar los consentimientos otorgados.
            </li>
            <li>
              Obtener confirmación acerca de si se están tratando datos personales que conciernen al usuario o no.
            </li>
            <li>
              Acceder a sus datos personales.
            </li>
            <li>
              Rectificar los datos inexactos o incompletos.
            </li>
            <li>
              Solicitar la supresión de sus datos cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos.
            </li>
            <li>
              Obtener de la limitación del tratamiento de los datos cuando se cumpla alguna de las condiciones previstas en la normativa de protección de datos.
            </li>
            <li>
              Solicitar la portabilidad de tus datos.
            </li>
            <li>
              Ponerse en contacto con el DPO de MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L.
            </li>
            <li>
              Interponer una reclamación en la autoridad de control (www.aepd.es) en caso de considerar vulnerados los derechos que le son reconocidos por la normativa aplicable en protección de datos.
            </li>
          </ul>
          <p>
            MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L. adopta los niveles de
            seguridad correspondientes requeridos por la citada normativa de
            Protección de Datos de Carácter Personal y demás normativa
            aplicable. Dichos niveles de seguridad son obligados para aquellas
            entidades que accedan a nuestra infor mación en virtud de una
            relación contractual y/o prestación de servicio, en aplicación del
            artículo 28 del Reglamento UE 2016/679 (RGPD)
          </p>
          <p>
            No obstante, no asume ninguna responsabilidad por los daños y
            perjuicios derivados de alteraciones que terceros pueden causar en
            los sistemas in formáticos, documentos electrónicos o ficheros del
            usuario.
          </p>
          <p>
            Se podrán utilizar cookies durante la prestación de servicios del
            sitio web. Las cookies son ficheros físicos de información personal
            alojados en el propio terminal del usuario. El usuario tiene la
            posibilidad de configurar su programa navegador de manera que se
            impida la creación de archivos cookie o se ad-vierta de la misma.
            Revise nuestra política de cookies a través del enlace que
            encontrará en esta web.
          </p>
          <p>
            Si opta a abandonar nuestro sitio web a través de enlaces a sitios
            web no pertenecientes a nuestra entidad, MARAGON EFICIENCIA EN
            CONSTRUCCIÓN S.L. no se hará responsable de las políticas de
            privacidad de dichos sitios web ni de las cookies que éstos puedan
            almacenar en el ordenador del usuario.
          </p>
          <p>
            Nuestra política con respecto al correo electrónico se centra en
            remitir únicamente comunicaciones que usted haya solicitado recibir
          </p>
          <p>
            Si prefiere no recibir estos mensajes por correo electrónico le
            ofreceremos a través de los mismos la posibilidad de ejercer su
            derecho de cancelación y re nuncia a la recepción de estos mensajes,
            en conformidad con lo dispuesto en el Título III, artículo 22 de la
            Ley 34/2002 de Servicios para la Sociedad de la Información y de
            Comercio Electrónico.
          </p>
        </el-collapse-item>
      </el-collapse>
    </div>
  </pageContent>
</template>

<script>
import pageContent from "@/components/pageContent.vue"
export default {
  name: "privacidad",
  components: {
    pageContent,
  },
  data() {
    return {
      activeNames: 0,
    }
  },
  methods: {},
}
</script>
<style lang="scss">
.privacidad-main {
  padding-left: 50px;
  padding-right: 50px;
  position: relative;
  top: -220px;
  .row-text {
    text-align: center;
    color: #fff;
    margin-bottom: 80px;
    .font-blod {
      font-size: calc(var(--font-size) *3);
      &.black {
        color: #000000;
      }
    }
  }
  .text {
    p {
      margin-bottom: 46px;
      font-size:calc( var(--font-size) - 2px);
    }
    b {
      font-size:calc( var(--font-size) - 2px);
    }
  }
}
// .collapse {
//   .header-icon {
//     font-size: 50px;
//   }
// }
</style>
